import mop from "../assets/resto/mop.jpg";
import start1 from "../assets/resto/start1.jpg";
import start2 from "../assets/resto/start2.jpg";
import resto1 from "../assets/resto/resto1.jpg";
import resto2 from "../assets/resto/engine.jpg";
import resto3 from "../assets/resto/clutch.jpg";
import generator from "../assets/hydrogenGas/generator.jpg";
import milling from "../assets/robotikS/milling.jpg";
import kitchen1 from "../assets/resto/kitchen1.jpg";
import kitchen2 from "../assets/resto/kitchen2.jpg";
import kitchen3 from "../assets/resto/kitchen3.jpg";
import kitchen5 from "../assets/resto/kitchen5.jpg";
import running from "../assets/resto/running.mp4";
import wheel from "../assets/resto/wheel.jpg";
import body1 from "../assets/resto/body1.jpg";
import body2 from "../assets/resto/body2.jpg";
import body3 from "../assets/resto/body3.jpg";
import final1 from "../assets/resto/final1.jpg";
import final2 from "../assets/resto/final2.jpg";
import final3 from "../assets/resto/final3.jpg";
import operating from "../assets/hydrogenGas/operating.mp4";
import xplosion from "../assets/hydrogenGas/xplosion.mp4";
import materov from "../assets/robotikS/materov.jpg";
import float1 from "../assets/robotikS/float.jpg";
import float2 from "../assets/robotikS/cad.png";
import milling1 from "../assets/robotikS/milling.jpg";
import milling2 from "../assets/robotikS/milling2.jpg";
import milling3 from "../assets/robotikS/milling3.png";
import group from "../assets/feijiclub/group.jpg";
import iphone1 from "../assets/feijiclub/iphone1.jpg";
import iphone2 from "../assets/feijiclub/iphone2.jpg";
import flight from "../assets/feijiclub/flight.mp4";
import thumbnailaoe from "../assets/aoe/thumbnail.jpg";
import cad1aoe from "../assets/aoe/blaster.jpeg";
import cad2aoe from "../assets/aoe/deployer.jpeg";
import cad3aoe from "../assets/aoe/assmbly.jpeg";
import arduino1 from "../assets/aoe/arduino1.jpg";
import arduino2 from "../assets/aoe/arduino2.jpg";
import assembling from "../assets/aoe/assemling.jpeg";
import lsrcut from "../assets/aoe/lsrcut.jpg";
import final from "../assets/aoe/final.jpg";
import craftsman1 from "../assets/craftsman/after.jpg";
import craftsman2 from "../assets/craftsman/before.jpg";
import craftsman3 from "../assets/craftsman/before1.jpg";
import runningexample2 from "../assets/ballMill/runningexample.mp4";
import insideBottle from "../assets/ballMill/insideBottle.jpg";
import assy from "../assets/nixieclock/assebling.jpg";
import schematic from "../assets/nixieclock/schematic.png";
import pcbFusion360 from "../assets/nixieclock/pcbFusion360.png";
import pcb1 from "../assets/nixieclock/pcb1.jpg";
import pcb2 from "../assets/nixieclock/pcb2.PNG";
import soldering1 from "../assets/nixieclock/soldering1.jpeg";
import testing1 from "../assets/nixieclock/testing1.jpeg";
import acrylicblock from "../assets/machining/acrylicblock.jpg";
import fryer from "../assets/machining/fryer.jpg";
import millingvid from "../assets/machining/millingvid.mp4";
import nuclearSoln from "../assets/machining/nuclearSoln.jpg";
import setup from "../assets/machining/setup.jpg";
import tormach from "../assets/machining/tormach.jpg";
import chcoo from "../assets/electroplating/chcoo.jpg";
import electroplated from "../assets/electroplating/electroplated.jpg";
import explodedsensor from "../assets/sensonoe/explodedSensor.png";
import cncMachine from "../assets/sensonoe/cncMachine.png";
import armoredSensor from "../assets/sensonoe/armoredSensor.png";
import dxf from "../assets/sensonoe/dxf.png";
import holder from "../assets/sensonoe/holder.png";
import cncvid from "../assets/sensonoe/cncvid.mp4";
import ee from "../assets/sensonoe/ee.png";
import radarSensor from "../assets/sensonoe/radarSensor.png";
import radarHolder from "../assets/sensonoe/radarHoder.mp4";
import batteryholder from "../assets/feijiclub/batteryholder.png";
import firewall from "../assets/feijiclub/firewall.png";
import rib from "../assets/feijiclub/rib.png";
import tailwheelholder from "../assets/feijiclub/tailwheelholder.png";
import endfit from "../assets/robotikS/endfit.jpg";
import leaktest from "../assets/robotikS/leaktest.mp4";
import racecarPDF from "../assets/manufacturing/Materials and Processes in Manufacturing Term Project.pdf";
import pdf1 from "../assets/feijiclub/WholePlaneDrawing1.pdf";
import pdf2 from "../assets/feijiclub/WholePlaneDrawing2.pdf";
import pdf3 from "../assets/feijiclub/WholePlaneDrawing3.pdf";
import pdf4 from "../assets/feijiclub/WholePlaneDrawing4.pdf";
import proposal from "../assets/feijiclub/2025DBF_Columbia University_PROPOSAL - Google Docs.pdf";
import report from "../assets/feijiclub/2025DBF_Columbia University_DESIGN_REPORT - Google Docs.pdf";
import thrusttestjig from "../assets/feijiclub/thrusttestjig.jpg";
import comppic from "../assets/feijiclub/2025competitionteampic.jpg";
import threedpmold from "../assets/feijiclub/3dpmold.jpg";
import cuttingfb from "../assets/feijiclub/cuttingfb.jpg";
import uscomposites from "../assets/feijiclub/uscomposites.jpg";
import wetmold from "../assets/feijiclub/wetmold.jpg";
import finished from "../assets/feijiclub/finished.jpg";
import teasercad from "../assets/feijiclub/teasercad.png";
import topdown from "../assets/feijiclub/topdownofplane.png";
import c20251 from "../assets/feijiclub/arizonacactuspic.jpg";
import c20252 from "../assets/feijiclub/planepicethanpinky.jpg";
import c20253 from "../assets/feijiclub/c20253.png";
import c20241 from "../assets/feijiclub/2024comp1img.jpg";
import c20242 from "../assets/feijiclub/2024comp2img.jpg";  
import c20243 from "../assets/feijiclub/2024comp3img.jpg";
import c20244 from "../assets/feijiclub/2024comp4img.jpg";
import scylidnerhead from "../assets/feijiclub/schroedercylhead.jpg";
import schroeder09thumb from "../assets/feijiclub/schroeder09thumb.png";
import scylandp from "../assets/feijiclub/schroedercylinderandpiston.jpg";
import scyl from "../assets/feijiclub/schroedercylinder.jpg";
import stiming from "../assets/feijiclub/schroedertiming.jpg";
import sconrod from "../assets/feijiclub/conrod.jpg";
import sventuri from "../assets/feijiclub/schroederventuri.jpg";
import scrank from "../assets/feijiclub/schroedercrank.jpg";
import scc from "../assets/feijiclub/schroedercrankcase.jpg";
import s09cad from "../assets/feijiclub/scroeder09cad.png";
import s09pdf from "../assets/feijiclub/Schroeder_09.pdf";
import vukejules from "../assets/vuke/vukejules.jpg";
import vukethumb from "../assets/vuke/researchthumb.jpg";
import vukecarttreat from "../assets/vuke/vukecarttreatmeat.jpg";
import vukeshgm from "../assets/vuke/vukeshgm.jpg";
import vukenotreat from "../assets/vuke/vukenotreat.gif";
import vukeuv from "../assets/vuke/vukeuv.gif";
import vukeuntgif from "../assets/vuke/vukeuntgif.gif";
import vukevid2 from "../assets/vuke/vukevid2.mp4";
import vukevid1 from "../assets/vuke/vukevid1.mp4";
import eyejig1 from "../assets/vuke/eyejig1.jpg";
import eyejig2 from "../assets/vuke/eyejig2.jpg";
import pcthumb from "../assets/pc/pcbuildthumb.jpg";
import pcwm from "../assets/pc/pcwm.jpg";
import pcps from "../assets/pc/pcps.jpg";
import pccase from "../assets/pc/pccase.jpg";
import pcmobo from "../assets/pc/pcmobo.jpg";
import pcehaul from "../assets/pc/pcehaul.jpg";
import pcfp from "../assets/pc/pcfp.jpg";
import robgp from "../assets/robotikS/robgp.jpg";
import robmaterovcomp from "../assets/robotikS/robmaterovcomp.jpg";
import robmatrovinsp from "../assets/robotikS/robmatrovinsp.jpg";
import robnyc from "../assets/robotikS/robnyc.jpg";
import robassclaw from "../assets/robotikS/robassclaw.jpg";
import rob3dparts from "../assets/robotikS/rob3dparts.jpg";
import robmotorclaw from "../assets/robotikS/robmotorclaw.jpg";
import robmachining from "../assets/robotikS/robmachining.MOV";
import robmachjig from "../assets/robotikS/robmachjig.jpg";
import robcam from "../assets/robotikS/robcam.png";
import robaf from "../assets/robotikS/robaf.jpg";
import robrov from "../assets/robotikS/robrov.jpg";
import st3dp from "../assets/solarTracker/st3dp.jpg";
import stcloseup from "../assets/solarTracker/stcloseup.jpg";
import stcoding from "../assets/solarTracker/stcoding.jpg";
import stgeneral from "../assets/solarTracker/stgeneral.jpg";
import stwiring from "../assets/solarTracker/stwiring.jpg";
import stworking from "../assets/solarTracker/stworking.mp4";
import stworking2 from "../assets/solarTracker/stworking2.mp4";
import today from "../assets/sensonoe/today.jpg"
import stainlessthreadedpost from "../assets/machining/stainlessthreadedpost.jpeg"
import camformachinedpartprofhone from "../assets/machining/camformachinedpartprofhone.png"
import completedpartsv1 from "../assets/machining/completedpartsv1.jpeg"
import machinedpartprofhone from "../assets/machining/machinedpartprofhone.jpeg"
import machinedpartsv2 from "../assets/machining/machinedpartsv2.jpeg"
import millingprocess from "../assets/machining/millingprocess.jpg"
import stackersamantha from "../assets/machining/stackersamantha.jpeg"
import blowtorch from "../assets/machineDesign/blowtorch.jpeg"
import machinedesignprofy from "../assets/machineDesign/machinedesignprofy.mp4"
import machinedesignslowmo from "../assets/machineDesign/machinedesignslowmo.mp4"
import slsprint from "../assets/machineDesign/slsprint.jpeg"
import bannerfootage from "../assets/feijiclub/bannerfootage.mp4"
import bannerprediction from "../assets/feijiclub/bannerprediction.png"
import codebannertest from "../assets/feijiclub/codebannertest.png"
import flagpoleholderwithflagpole from "../assets/feijiclub/flagpoleholderwithflagpole.jpeg"
import flagpolemount from "../assets/feijiclub/flagpolemount.jpeg"
import forcewindspeeddata from "../assets/feijiclub/forcewindspeeddata.png"
import groupbannerbox from "../assets/feijiclub/groupbannerbox.JPG"
import gwbridgebackgropp from "../assets/feijiclub/gwbridgebackgropp.JPG"
import mepiercebanner from "../assets/feijiclub/mepiercebanner.JPG"
import printfarm from "../assets/feijiclub/printfarm.mp4"
import truckback from "../assets/feijiclub/truckback.JPG"
import truckbackbanner from "../assets/feijiclub/truckbackbanner.JPG"
import truckdrivingbanner from "../assets/feijiclub/truckdrivingbanner.JPG"
import truckleaving from "../assets/feijiclub/truckleaving.JPG"
import bikebalancingworking from "../assets/compAspects/bikebalancingworking.mp4"
import csreport from "../assets/compAspects/Report.pdf"
import closedrobot from "../assets/roboticstudio/closedrobot.jpg"
import modularity from "../assets/roboticstudio/modularity.jpg"
import openedrobot from "../assets/roboticstudio/openedrobot.jpg"
import robot from "../assets/roboticstudio/robot.jpg"
import roboticstudio from "../assets/roboticstudio/roboticstudio.mp4"
import rxnwheelbikeview from "../assets/compAspects/rxnwheelbikeview.jpeg"
import rnwheelview from "../assets/compAspects/rnwheelview.jpeg"
import machining from "../assets/machining/machining.jpeg"
import machiningjig from "../assets/machining/machiningjig.jpeg"
import supergluemethod from "../assets/machining/supergluemethod.jpeg"
import robotparts from "../assets/roboticstudio/robotparts.jpeg"
import machinedesignthumb from "../assets/machineDesign/machinedesignthumb.jpeg"
import thrusttest from "../assets/feijiclub/thrusttest.mp4";
import vacuumbaggingsetup from "../assets/feijiclub/vacuumbaggingsetup.jpeg";
import vacuumbagged from "../assets/feijiclub/vacuumbagged.jpeg";
import trimingmold from "../assets/feijiclub/trimingmold.jpeg";
import thruststand from "../assets/feijiclub/thruststand.jpg";
import taping from "../assets/feijiclub/taping.jpeg";
import tail from "../assets/feijiclub/tail.jpeg";
import moldverticaltower from "../assets/feijiclub/moldverticaltower.jpg";
import moldv2sanded from "../assets/feijiclub/moldv2sanded.jpg";
import moldv2alt from "../assets/feijiclub/moldv2alt.png";
import moldv2 from "../assets/feijiclub/moldv2.png";
import moldsanded from "../assets/feijiclub/moldsanded.jpg";
import moldpresanded from "../assets/feijiclub/moldpresanded.jpg";
import moldhalveswithwings from "../assets/feijiclub/moldhalveswithwings.jpeg";
import moldhalves from "../assets/feijiclub/moldhalves.jpeg";
import layupbirdseye2 from "../assets/feijiclub/layupbirdseye2.jpeg";
import layupbirdseye from "../assets/feijiclub/layupbirdseye.jpeg";
import fullplane from "../assets/feijiclub/fullplane.jpeg";
import finishedmold from "../assets/feijiclub/finishedmold.jpeg";
import trimmed from "../assets/feijiclub/trimmed.jpeg";
import comp2026report from "../assets/feijiclub/2026DBF_Columbia_University_DESIGN_REPORT.pdf"







export const ProjectList = [
  {
    id: 0,
    name: "Columbia University AIAA Club",
    thumbnail: comppic,
    sections: [
      { text:"Plane club is where I spend most of my extra time here at Columbia. Below you will find pictures of the plane from the 2025 competition in Tucson, Arizona, as well as the experience from last year's AIAA Design, Build, Fly (DBF) competition in Wichita, Kansas. As Chief Design Engineer, I am in charge of the design of the airplane, as well as the design proposal and report, 6 and 60 page documents (respectively) regarding the technical details of the aircraft. We were able to get 15th place (the highest ever!) during our most recent (2025) competition attempt." },  
      {
        text: (
            <>
            If you want to learn more, check out the website (I created) at:{" "}
            <a 
                href="https://www.cuairplanes.com" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: "#0077cc", textDecoration: "underline" }}
            >
                www.cuairplanes.com
            </a>
            .
            </>
        ),
      },
      { text: "This year (2026), for the first time in Columbia AIAA History, I spearheaded the manufacturing of a composite fuselage. Because our university had no prior experience or established practices for composite manufacturing, I had to self-teach the entire process, researching and purchasing all the materials required for the process."},
      { text: "A practice mold and resulting fiberglass parts that were created to test the feasability of this manufacturing process and to learn from mistakes", images:[moldv2sanded,moldv2,moldv2alt] },
      { text: "Mold mass printing:", videos: [printfarm] },
      { text: "Mold construction process: unsanded, sanded, and primed/waxed ready for making parts:", images: [moldpresanded,moldsanded,finishedmold,moldverticaltower] },
      { text: "And the layup process. This took use 3 tries to get right. The first time, we experienced thermal runaway after we mixed our epoxy all at once instead of in small batches. The second time, the fiberglass got ruffled and displaced from the mold walls. The third time, we finally got a usable product:", images: [layupbirdseye,layupbirdseye2,vacuumbaggingsetup,taping,vacuumbagged]},
      { text: "The cleanup process and the final product:", images: [trimingmold, trimmed, moldhalves, moldhalveswithwings, fullplane]},
      { text: "2026 competition requires the plane to pull a banner behind it. In order to get some sense of what the relationship between the banner size, airspeed, and drag force, we did some testing:", images: [truckbackbanner] },
      { text: "Everything began in the machine shop, where I machined the mount for the pole that would support the banner during testing.", images: [flagpolemount,flagpoleholderwithflagpole] },
      { text: "Then, we drove out to New Jersey across the George Washington Bridge and did some testing of the drag force on the banner at different airspeeds.", images: [truckleaving, gwbridgebackgropp,groupbannerbox,truckback, mepiercebanner] },
      { text: "On the first try, the data was corrupted. On the second try, the data was simply not recorded. On the third try, we finally got some data (Testing took almost 2 whole months...)", images: [truckdrivingbanner] },
      { text: "Footage of the banner actually being tested", videos: [bannerfootage] },
      { text: "And a snapshot of the data analysis process:", images: [codebannertest,forcewindspeeddata,bannerprediction] },
      { text: "In order to verify thrust claims from the motor manufacturer, our team built a thrust stand, equipped with a load cell and current meter. I was reponsible for the design and manufacture of the aluminum brackets that fix the motor and loadcell to the aluminum extrusion: ", videos: [thrusttest], images:[thruststand] },
      { text: "The Columbia 2026 AIAA DBF Design Report:", pdfs:[comp2026report]},
      { text: "2025 competition aircraft 3-view", pdfs: [pdf1] },
      { text: "2025 competition aircraft payload overview", pdfs: [pdf2] },
      { text: "2025 competition aircraft exploded view", pdfs: [pdf3] },
      { text: "2025 competition aircraft systems overview", pdfs: [pdf4] },
      { text: "I was in charge for the 2025 AIAA DBF Design Report & Proposal", pdfs:[report, proposal]},
      { text: "Moving forward, we will be attempting composite fuselage. Here is what I worked on over the summer as a proof of concept:", images:[teasercad,topdown]},
      { text: "And the fiberglass layup first attempt", images:[threedpmold,cuttingfb,uscomposites,wetmold,finished]},
      { text: "2025 competition pictures", images:[c20251,c20252, c20253]},
      { text: "Thrust test on jig that I created", images:[thrusttestjig]},
      { text: "2024 competition, we got 47th place. A great learning experience:", images:[c20241,c20242,c20243,c20244]},
      { text: "CAD renderings of tail wheel, battery holder, firewall, and rib", images: [tailwheelholder, batteryholder, firewall, rib] },
      { text: "Wind tunnel and flight testing", images: [iphone1, iphone2], videos: [flight] },
    ],
  },

    {
    id: 1,
    name: "Machining",
    thumbnail: flagpolemount,
    sections: [
      { text: "I was hired by Professor James Hone of Columbia University's Mechanical Engineering Department to help manufacture some parts for his research lab.", images: [completedpartsv1, machinedpartsv2] },
      { text: "Here is a behind the scenes of a cam program and the finished part:", images: [camformachinedpartprofhone, machinedpartprofhone] },
      { text: "I have found that the revolutionary tape and superglue method is especially useful for fast, simple workholding", images: [millingprocess,machining,machiningjig,supergluemethod] },
      { text: "Somne work on the TRAK lathe, a threaded post I made of 316L Stainless Steel (very annoying machining material properties)", images: [stainlessthreadedpost] },
      { text: "My machined parts being put to use in groundbreaking research efforts", images: [stackersamantha] },
      { text: "Machining an aluminum pole holder for the airplane club:", images: [flagpolemount, flagpoleholderwithflagpole] },
      { text: "The Tormach and Fryer milling machines, both of which I am certified to use", images: [tormach, fryer] },
      { text: "One of my first parts", images: [acrylicblock], videos: [millingvid] },
      { text: "Extraneous images taken during various milling procedures", images: [setup, nuclearSoln] },
    ],
  },

   {
    id: 2,
    name: "Machine Design",
    thumbnail: machinedesignthumb,
  sections: [
  {
    text: (
      <>
        This course is required for all senior mechanical engineers at Columbia. The objective of this class is to learn about machines in industry settings, and concurrently utilize that knowledge to build one of our own. The machine is to press 1 of 3 button pairs depending on which lights up, gaining a point per each sucessful press. Occasionally, the green bonus button will light up, and you are able to press it to gain 3 points. 

        Our team chose an unconventional, overengineered approach. We compacted the entire 4 bar linkage into an eight of the form factor that other teams had. Where other teams had heavy aluminum linkages, we had light weight SLS nylon components. Our follow link was manufactured from a malleable galvanized stell wire that was then heat treated to become stiff and resistive. 

        We scored 308 points over a 1 minute testing period, setting a record for our class (second highest was 200), as well as the previous years, (score to beat was 220).  
        </>
    ),
  },
  { text: "The propane blowtorch and steel wire I bought and used to manufacture a component in the machine: ", images: [blowtorch]},
  { text: "Video of it running in slow motion:", videos: [machinedesignslowmo]},
  { text: "Video of demonstration to Professor Yevgeniy Yesilevskiy:", videos: [machinedesignprofy]},
  { text: "SLS printed main link that weighed around `~20 g where other groups had aluminum links weighing at least 100 g", pdfs: [slsprint]},

],
  },

       {
    id: 3,
    name: "Computational Aspects of Robotics",
    thumbnail: rnwheelview,
  sections: [
  {
    text: (
      <>
        This is the capstone of a Columbia CS course called Computational Aspects of Robotics. We were taught about the intersection between robots and coding, and had to pick a project to showcase our understanding. In conjunction with Shah Rifat Alam Bhuiyan, we were able to put together a reaction wheel balancing bike.
        </>
    ),
  },
  { text: "What the bike looks like ", images: [rnwheelview,rxnwheelbikeview]},
  { text: "Video of it running:", videos: [bikebalancingworking]},
  { text: "Report that captures the all of the technical details of this project.", pdfs: [csreport]},

],
  },

        {
    id: 4,
    name: "Robotics Studio",
    thumbnail: robot,
  sections: [
  {
    text: (
      <>
        This course allows students to design and implement their very own quadruped robot. Follow along to see my experience: 
        </>
    ),
  },
  { text: "The robot was designed to be very modular", images: [modularity,robotparts]},
  { text: "Robot in opened and closed configuration:", images: [openedrobot,closedrobot]},
  { text: "Glamor photo of the robot", images: [robot]},
  { text: "Video summarizing the experience (volume up especially if you like Star Wars!):", videos: [roboticstudio]},
  
],
  },

    {
    id: 5,
    name: "MECE E3610 Manufacturing Racecar Project",
    thumbnail: require("../assets/manufacturing/bluecast1.jpg"),
    sections: [
      {
        text: "I worked for the professor teaching MECE E3610: Materials and Processes in Manufacturing (a course required for all Columbia Mechanical Engineering juniors) to develop a final project for 160+ students. The objective was to utilize the manufacturing methods taught during the semester to make a 1920s-style race car model.",
        images: [require("../assets/manufacturing/redmold.jpg"), require("../assets/manufacturing/siliconscalepic.jpg"), require("../assets/manufacturing/bluecast1.jpg")],
      },
      {
        text: "Silicone casting process and final assembly",
        images: [require("../assets/manufacturing/finalcar.jpg")],
        pdfs: [racecarPDF],
      },
    ],
  },
  {
    id: 6,
    name: "Vukelic Group Research",
    thumbnail: vukethumb,
    sections: [
      { text: "During summer 2024 - may 2025, I researched under Professor Sinisa Vukelic at Columbia.  His lab is attempting to create a less invasive LASIK laser eye treatment. During my time there, I gained experience with femtosecond lasers, corneal topography, second harmonic generation microscopy techniques. Here's what it was like:" },
      { text: "laser treatment of rabbit cornea", videos: [vukevid1] },
      { text: "gauging plasma spark size as a function of laser power", videos: [vukevid2] },
      { text: "cornea treated with laser (new research):", images: [vukeuntgif] },
      { text: "cornea treated with uv crosslinking (industry standard):", images: [vukeuv] },
      { text: "control cornea(no treatment):", images: [vukenotreat] },
      { text: "early version of corneal topographer jig I designed and manufactured (with attempted 3d printed linear bearings, and then proper linear bearings):", images: [eyejig1,eyejig2] },
      { text: "second harmonic generation microscopy:", images: [vukeshgm] },
      { text: "devising cartilage treatment apparatus:", images: [vukecarttreat] },
      { text: "attending summer research symposium:", images: [vukejules] },
    ],
  }, 
  {
    id: 7,
    name: "Sensoneo Slovakia",
    thumbnail: explodedsensor,
    sections: [
      { text: "Sensoneo Slovakia is a company dedicated to making waste management more sustainable through small, durable ioT sensors. I interned here for summer of 2023, and had a great experience"},
      { text: "UPDATE 2025: after revisiting my old team after 3 years of absence, I was more than pleasantly surprised to see that the machine I had created still in everyday use:", images:[today]},
      { text: "Housing designed to shield sensor from damage when mounting in high-traffic areas", images: [armoredSensor] },
      { text: "DXF path for CNC of mounting brackets & electronics control box for stepper motor drivers", images: [dxf, ee] },
      { text: "Finalized 2-axis CNC accelerometer testing rig", images: [cncMachine], videos: [cncvid] },
      { text: "Prototype for one-handed replacement sensor mounting compartment", images: [holder] },
      { text: "Altered sensor housing with optimized lens shape that improved clarity of radar module data", images: [radarSensor], videos: [radarHolder] },
    ],
  },

  {
    id: 8,
    name: "Schroeder 09 Engine",
    thumbnail: schroeder09thumb,
    sections: [
      { text: "Online, I found plans for a miniature internalcombustion engine here", pdfs: [s09pdf] },
      { text: "Cad I made from the hand-drawn engineering drawings:", images: [s09cad ] },
      { text: "With time, effort, and perserverance, I was able to make these parts so far:", images: [scyl,sconrod,scrank,scylandp,scylidnerhead,sventuri,stiming,scc] },
    ],
  },
  {
    id: 9,
    name: "Solar Tracker",
    thumbnail: stcloseup,
    sections: [
      { text: "For the culmination of the course Mechanical Engineering Lab : 2, Columbia Junior Mechanical Engineering students got together in groups of 3-4 to create a device capable of autonomously tracking the ligh source in a room. Here is my group's work" },
      { text: "Building process", images: [st3dp,stgeneral,stwiring ] },
      { text: "Closeup", images: [stcloseup,] },
      { text: "Final product", videos: [stworking,stworking2] },
    ],
  },
  {
    id: 10,
    name: "Motobecane Mobylette Restoration",
    thumbnail: mop,
    sections: [
      { text: "This is a Moped from 1977 that I overhauled due to a seized engine", images: [start1, start2] },
      { text: "Beginning of the Restoration Process...", images: [resto1, resto2, resto3, wheel] },
      { text: "Overhauling the av7 Engine", videos: [running] },
      { text: "Body Work", images: [body1, body3, body2] },
      { text: "Finished Product", images: [final1, final2, final3] },
    ],
  },
   {
    id: 11,
    name: "PC Build",
    thumbnail: pcthumb,
  sections: [
  {
    text: (
      <>
        Summer of 2024 is when I built my first PC. Being unsatisfied about the
        thermal performance of my 2015 Surface Book, I looked into alternatives,
        and found that PC building (when done cleverly) could yield a powerful
        machine at a fraction of commercial cost. Here are my specs:
        <ul>
          <li>CPU: AMD Ryzen 7 5800X</li>
          <li>Mobo: Gigabyte B550M DS3H AC Micro ATX</li>
          <li>GPU: Gigabyte AERO OC GeForce RTX 4060 8 GB</li>
          <li>Case: Fractal Design Pop Mini Air MicroATX</li>
          <li>Power Supply: Cougar VTE 600 W</li>
          <li>Cooling: ID-COOLING DASHFLOW 240 BASIC 82.5 CFM Liquid CPU Cooler</li>
        </ul>
      </>
    ),
  },
  { text: "electronics haul: ", images: [pcehaul]},
  { text: "installing components: ", images: [pcmobo]},
  { text: "opening case: ", images: [pccase]},
  { text: "power supply: ", images: [pcps]},
  { text: "wire management: ", images: [pcwm]},
  { text: "finished setup: ", images: [pcfp]},

],
  },

  
  {
    id: 12,
    name: "Columbia University Robotics Club",
    thumbnail: milling,
    sections: [
      { text: "MATE ROV", images: [materov] },
      { text: "Autonomous float robot for MATE ROV contest", images: [float2, float1] },
      { text: "Machining components in Columbia University Machine Shop", images: [milling1, milling2, milling3] },
      { text: "Precision machined endcap integrating volumetric syringe", images: [endfit] },
      { text: "Leak test on the float", videos: [leaktest] },
      { text: "Claw that I designedlaw", images: [robmotorclaw, rob3dparts, robassclaw] },
      { text: "ROV in NYC, and MATE ROV Competition (inspection, and aquatic center)", images: [robnyc,robmatrovinsp,robmaterovcomp] },
      { text: "Team Picture", images: [robgp] },

    ],
  },
  {
    id: 13,
    name: "Art Of Engineering Project",
    thumbnail: thumbnailaoe,
    sections: [
      { text: "CAD of project conceptualization", images: [cad1aoe, cad2aoe, cad3aoe] },
      { text: "Assembling project", images: [arduino1, arduino2, assembling, lsrcut] },
      { text: "Final product", images: [final, thumbnailaoe] },
    ],
  },

  {
    id: 14,
    name: "Ball Mill Creation",
    thumbnail: insideBottle,
    sections: [
      { text: "Ball mill that I created by repurposing an old stand mixer and various stray components from around the house.", videos: [runningexample2] },
      { text: "Results after 1 day of runtime", images: [insideBottle] },
    ],
  },
  {
    id: 15,
    name: "Craftsman Jigsaw",
    thumbnail: craftsman1,
    sections: [
      { text: "Before restoration", images: [craftsman2, craftsman3] },
      { text: "After restoration", images: [craftsman1] },
    ],
  },
  {
    id: 16,
    name: "Nixie Clock",
    thumbnail: assy,
    sections: [
      { text: "PCB design using Autodesk Fusion 360", images: [pcb1, pcb2, schematic, pcbFusion360] },
      { text: "Testing & Soldering", images: [testing1, soldering1] },
      { text: "Assembling Components", images: [assy] },
    ],
  },
  {
    id: 17,
    name: "Hydrogen Gas Generator",
    thumbnail: generator,
    sections: [
      { text: "Learning about electrolysis in chem — I could now believe water was composed of explosive gas.", videos: [operating] },
      { text: "With pencil-lead electrodes, plastic bottles, and tubing, I was able to verify.", images: [generator], videos: [xplosion] },
    ],
  },
  {
    id: 18,
    name: "Electroplating",
    thumbnail: chcoo,
    sections: [
      { text: "Homemade Cu(CH3COO) (aq) for electroplating", images: [chcoo] },
      { text: "Electroplated quarter and control for comparison", images: [electroplated] },
    ],
  },
];



